import angular from 'angular';
import moment from 'moment';
import 'ui-select';
import './logsServices';

const userOrderControllers = angular.module('applicationModule.logsControllers', ['applicationModule.logsServices', 'ui.select']);

userOrderControllers.controller('LogsController', ['$scope', '$rootScope', '$stateParams', '$filter', 'NgTableParams', 'Logs', 'AppsoupAPI', 'Permissions', 'growl', function ($scope, $rootScope, $stateParams, $filter, NgTableParams, Logs, AppsoupAPI, Permissions, growl) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('logs');
    $scope.application_id = $stateParams.application_id;
    $scope.check = false;
    $scope.search = {};
    $scope.searchItem = null;

    $scope.review = {};
    $scope.reviewDetails = {};

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Logs.getList($scope.application_id, params && params._params ? params._params : {})
                .then(function (response) {
                    params.total(response.total);
                    params.count(response.per_page);
                    params.page(response.current_page);

                    if (angular.isDefinedNotNull($stateParams.searchLogs)) {
                        $scope.search = $stateParams.searchLogs;
                        $scope.searchLogs($scope.search);
                    }

                    return response.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    // DatePickers
    $scope.report = {
        start_date: new Date(),
        end_date: new Date(),
        details: false
    };

    $scope.popup_start = {
        opened: false
    };

    $scope.popup_end = {
        opened: false
    };

    $scope.format = 'dd-MM-yyyy';

    $scope.dateOptions = {
        dateDisabled: false,
        formatYear: 'yy',
        startingDay: 1
    };

    $scope.startDate = function () {
        $scope.popup_start.opened = true;
    };

    $scope.endDate = function () {
        $scope.popup_end.opened = true;
    };

    $scope.generateCSV = function (report) {
        const endDate = moment(report.end_date).format('YYYY-MM-DD');
        const startDate = moment(report.start_date).format('YYYY-MM-DD');
        const details = report.details;
        $scope.isLoadingExport = true;
        Logs.downloadReport($scope.application_id, endDate, startDate, details)
            .then(function (result) {
                let data = result.data;

                if (angular.isDefined(data.error)) {
                    growl.error(data.error);
                } else if (data) {
                    angular.openInNewTab(data);
                } else {
                    growl.error(data.error);
                }
                //                        $window.open(data, '_blank');
            }).finally(function () {
            $scope.isLoadingExport = false;
        });
    };

    $scope.searchLogs = function (search) {
        $scope.isFind = true;

        search.from_date = $filter('date')(search.from_date, 'yyyy-MM-dd');
        search.to_date = $filter('date')(search.to_date, 'yyyy-MM-dd');

        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.system)) {
            $scope.tableParams._params.system = undefined;
        }
        $stateParams.searchLogs = null;
        $scope.searchItem = null;
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
            if (angular.isDefined($scope.tableParams._params.from_date)) {
                $scope.tableParams._params.from_date = undefined;
            }
            if (angular.isDefined($scope.tableParams._params.to_date)) {
                $scope.tableParams._params.to_date = undefined;
            }
        });
    }, true);
}]);

export default userOrderControllers;
